import { createContext, useReducer, ReactNode, Dispatch } from 'react';

import {
  CollaboratorsReducer,
  initialState,
  InitialStateType,
} from './context-reducer';

type CollaboratorsProviderProps = {
  children: ReactNode;
};

const CollaboratorsContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null,
});

const CollaboratorsProvider = ({ children }: CollaboratorsProviderProps) => {
  const [state, dispatch] = useReducer(CollaboratorsReducer, initialState);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <CollaboratorsContext.Provider value={{ state, dispatch }}>
      {children}
    </CollaboratorsContext.Provider>
  );
};

export { CollaboratorsContext, CollaboratorsProvider };
